export default "__VITE_ASSET__CjfzzTHN__"